module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.b6db46d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/dropdown-arrow.svg
// module id = 689
// module chunks = 0